<template>
  <main>
    <div class="hubday-tabs enabled dashboard">
      <div id="planning" class="planning-container hubday-tab">
        <Planning></Planning>
      </div>
      <div id="agenda" class="agenda-container hubday-tab">
        <Agenda></Agenda>
      </div>
      <div id="resources" class="resources-container hubday-tab">
        <Resources></Resources>
      </div>
    </div>
    <ul id="tabs" class="tabs hide-on-med-and-up">
      <li class="tab col s3">
        <a href="#planning">
          <i class="material-icons-outlined">view_day</i>
          <span class="tab-name">Planning</span>
        </a>
      </li>
      <li class="tab col s3">
        <a href="#agenda">
          <i class="material-icons-outlined">book</i>
          <span class="tab-name">Agenda</span>
        </a>
      </li>
      <li class="tab col s3">
        <a href="#resources">
          <i class="material-icons-outlined">folder</i>
          <span class="tab-name">Ressources</span>
        </a>
      </li>
    </ul>
  </main>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.next-enter-active,
.next-leave-active,
.previous-enter-active,
.previous-leave-active {
  transition: all 0.2s;
}
.next-enter,
.next-leave-active,
.previous-enter,
.previous-leave-active {
  opacity: 0;
}
.next-enter,
.previous-leave-active {
  transform: translateX(31px);
}
.next-leave-active,
.previous-enter {
  transform: translateX(-31px);
}
</style>

<style scoped>
.hubday-tabs {
  max-width: 1200px; /* 400px fois le nombre de colonnes */
}

@media only screen and (min-width: 601px) {
  .hubday-tabs {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    gap: 12px 12px;
    grid-template-areas: "planning-container agenda-container resources-container";
  }

  .planning-container {
    grid-area: planning-container;
  }

  .agenda-container {
    grid-area: agenda-container;
  }

  .resources-container {
    grid-area: resources-container;
  }
}

@media screen and (min-width: 601px) and (max-width: 900px),
  (min-width: 993px) and (max-width: 1200px) {
  .hubday-tabs {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto 1fr;
    grid-template-areas: "planning-container agenda-container" "planning-container resources-container";
  }

  .planning-container {
    grid-area: planning-container;
  }

  .agenda-container {
    grid-area: agenda-container;
  }

  .resources-container {
    grid-area: resources-container;
  }
}
</style>

<script>
import Planning from "@/components/Planning";
import Agenda from "@/components/Agenda";
import Resources from "@/components/Resources";

import { mapState } from "vuex";
import M from "materialize-css";

export default {
  components: {
    Planning,
    Agenda,
    Resources,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    var instance = M.Tabs.init(document.querySelector(".tabs"));
  },
};
</script>